export default function init(handler) {
  handler.mock.onGet(/\/user/).reply(
    200,
    JSON.stringify({
      msg: 'OK',
      code: 200,
      data: {
        user: {
          username: 'admin'
        }
      }
    })
  )
}
